var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AboutUs"},[_c('top-title'),_c('top-images'),_c('insist'),_c('company-profile'),_c('how-are-we-doing'),_c('papers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }